 
const TNCategoriesSlider = (() => {
  const instances = {};

  function init(sectionId) {
    const track = document.getElementById(`tncats-track-${sectionId}`);
    if (!track) return;

    const inner   = track.querySelector('.tncats-inner');
    const bar     = document.getElementById(`tncats-progress-${sectionId}`);
    const slides  = inner ? inner.querySelectorAll('.tncats-slide') : [];

    if (!inner || slides.length === 0) return;

    // ── helpers ──────────────────────────────────────────────
    const getCSSVar = (name) => parseFloat(
      getComputedStyle(inner).getPropertyValue(name).trim()
    );

    const getColumns = () => {
      const vw = window.innerWidth;
      if (vw <= 768)  return getCSSVar('--tncats-mobile-cols')  || 3.5;
      if (vw <= 1024) return getCSSVar('--tncats-tablet-cols')  || 6;
      return               getCSSVar('--tncats-desktop-cols') || 9;
    };

    const getGap = () => {
      const vw = window.innerWidth;
      if (vw <= 768)  return 12;
      if (vw <= 1024) return 16;
      return 24;
    };

    const applyWidths = () => {
      const cols      = getColumns();
      const gap       = getGap();
      // Use the track's visible width as the reference
      const available = track.clientWidth;
      const slideW    = (available - gap * (cols - 1)) / cols;

      if (slideW <= 0) return;

      inner.style.gap = `${gap}px`;
      slides.forEach(slide => {
        slide.style.flex = `0 0 ${slideW}px`;
      });

      updateProgress();
    };

    const updateProgress = () => {
      if (!bar) return;
      const max      = track.scrollWidth - track.clientWidth;
      const progress = max > 0
        ? Math.min(100, Math.max(5, (track.scrollLeft / max) * 100))
        : 100;
      bar.style.width = `${progress}%`;
    };

    // ── event listeners ───────────────────────────────────────
    track.addEventListener('scroll', updateProgress, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyWidths, 80);
    });

    // ── initial run ───────────────────────────────────────────
    applyWidths();
    instances[sectionId] = { applyWidths };
  }

  return { init };
})();
